import React, { useState } from 'react'
import { TopCitiesMainContainer } from './TopCitiesMainContainer'

import GenericLazyLoadImage from 'components/generic/GenericLazyLoadImage'
import { H1 } from 'components/generic/HomePageComponents'
import { FooterNavItemsContainer } from './Styled'
import DownArrowIcon from 'Images/SVG/ChevronDownWhite.svg'
import { FooterNavItems } from './FooterNavItems'

export const TopCities = ({ topCitiesData, footerData }) => {
  if (!footerData || !topCitiesData) {
    return null
  }

  const [showTopCities, toggleTopCities] = useState(false)

  return (
    <TopCitiesMainContainer>
      <H1
        color='white'
        fontSize='20px'
        width={['90vw', '90vw', '758px', '992px']}
        textAlign='center'
        mb='0px'
      >
        <GenericLazyLoadImage
          src={DownArrowIcon}
          height='20px'
          width='20px'
          pr='5px'
          alt='Down Arrow Icon Button'
          onClick={() => toggleTopCities(!showTopCities)}
        />
        {topCitiesData}
      </H1>
      <FooterNavItemsContainer show={showTopCities}>
        <FooterNavItems navigationItems={footerData} />
      </FooterNavItemsContainer>
    </TopCitiesMainContainer>
  )
}

export default TopCities
